import Modal from "./Modal";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Alert, Container, Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import classes from './MessageDialog.module.css';

const MessageDialog = (props) => {
    return (
        <Modal modalClass={classes.modal} onClose={props.onClose}>
            <Form>
                <Container className="pt-3">
                    <Row>
                        <Col xs={12}>
                            <Alert key={props.variant} variant={props.variant}>
                                <span className="fw-bolder">{props.header}</span>
                            </Alert>
                            <span>{props.message}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <hr />
                        </Col>
                    </Row>
                    <Row>
                        <Col className={'text-end'} xs={12}>
                            <Button onClick={props.onClose} variant="secondary" type="button" size="sm" className="m-1">
                                <FontAwesomeIcon icon={faCheck} />&nbsp;Ok
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </Modal>
    );
};

export default MessageDialog;